"use strict";

var _regeneratorRuntime = require("/opt/atlassian/pipelines/agent/build/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/opt/atlassian/pipelines/agent/build/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _slicedToArray = require("/opt/atlassian/pipelines/agent/build/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAudioData = void 0;

var react_1 = require("react");

var remotion_1 = require("remotion");

var get_audio_data_1 = require("./get-audio-data");

var useAudioData = function useAudioData(src) {
  if (!src) {
    throw new TypeError("useAudioData requires a 'src' parameter");
  }

  var mountState = (0, react_1.useRef)({
    isMounted: true
  });
  (0, react_1.useEffect)(function () {
    var current = mountState.current;
    current.isMounted = true;
    return function () {
      current.isMounted = false;
    };
  }, []);

  var _ref = (0, react_1.useState)(null),
      _ref2 = _slicedToArray(_ref, 2),
      metadata = _ref2[0],
      setMetadata = _ref2[1];

  var fetchMetadata = (0, react_1.useCallback)( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var handle, data;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            handle = (0, remotion_1.delayRender)("Waiting for audio metadata with src=\"".concat(src, "\" to be loaded"));
            _context.next = 3;
            return (0, get_audio_data_1.getAudioData)(src);

          case 3:
            data = _context.sent;

            if (mountState.current.isMounted) {
              setMetadata(data);
            }

            (0, remotion_1.continueRender)(handle);

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), [src]);
  (0, react_1.useEffect)(function () {
    fetchMetadata();
  }, [fetchMetadata]);
  return metadata;
};

exports.useAudioData = useAudioData;